import { FaBrain, FaCheck, FaCloud, FaTimes, FaUsers } from "react-icons/fa";
import Footer from "../../components/footer/Footer";
import Menu from "../../components/menu/menu";
import classes from "./pricing.module.scss";
import ToggleSwitch from "../../elements/toggleSwitch/toggleSwitch";
import { FormEvent, useEffect, useState } from "react";
import Modal from "../../elements/Modal/modal";
import InformMe from "../../components/inform-me/informMe";
import { toast } from "react-toastify";
import { User } from "../../models/User";
import { Http, UseHttpAssistant, useHttpClient } from "@codes-on-us/assistant";
import { loadStripe, Stripe } from "@stripe/stripe-js";

export default function Pricing() {
  const [isMonthly, setIsMonthly] = useState(true);
  const [isModalOpen, setModalOpen] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState("");
  const [plans, setPlans] = useState<any>([]);
  const [user, setUser] = useState<User>();
  const [loading, setLoading] = useState(true);
  const { Get, Post } = UseHttpAssistant();
  const { isLoading, send } = useHttpClient<string>();
  const stripePromise = loadStripe(
    process.env.REACT_APP_STRIPE_PUBLIC_KEY as string,
  );

  const checkUser = async () => {
    try {
      var currentUser = (await Get("/Auth/Ping"))?.value as User;
      if (currentUser) setUser(currentUser);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    checkUser();
  }, []);

  const handleOpenModal = (planName: string) => {
    setModalOpen(true);
    setSelectedPlan(planName);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedPlan("");
  };

  const fetchPlans = async () => {
    const response = await fetch(
      `${process.env.REACT_APP_BASE_URL}/Plans/ActivePlans`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      },
    );

    if (response && response.ok) {
      const res = await response.json();
      if (!res.failed) {
        setPlans(res.value);
        console.log(plans);
      } else toast.error(res.message || "Failed to load plans");
    } else {
      toast.error("Failed to load plans");
    }
  };

  useEffect(() => {
    fetchPlans();
  }, []);

  const startActivation = async (selectedPlanId: string) => {
    //event.preventDefault();
    if (user) {

      const currentPlan = (
        await Get("/Payment/UserPlans", {
          atDate: new Date().toISOString().split("T")[0],
        })
      )?.value as any[];

      if (currentPlan && currentPlan.length > 0) {
        window.location.href = process.env.REACT_APP_PANEL_ADDRESS as string;
      }

      
      const { response, errorMessage } = await send({
        url: "/payment/checkoutSession",
        method: Http.POST,
        data: {
          planId: selectedPlanId,
        },
      });

      if (errorMessage) {
        toast.error(errorMessage);
        return;
      }
      if (response) {
        const res = response as any;
        const sessionId = res.value?.id;
        const stripe: Stripe | null = await stripePromise;
        if (stripe) {
          const result = await stripe.redirectToCheckout({
            sessionId: sessionId,
          });

          if (result.error) {
            toast.error(result.error.message);
          }
        }
      }
    }
  };

  return (
    <div className={classes.module}>
      <div className={classes.header}>
        <Menu />
      </div>
      <div className={classes.content}>
        <div className={classes.title}>
          <h1>Choose Your Perfect Plan</h1>
          <span>
            Transform your dental practice with AI-powered solutions tailored to
            your needs
          </span>
        </div>
        <div className={classes.priodToggle}>
          <ToggleSwitch
            label1="Monthly"
            label2="Annual"
            label3="Save 20%"
            isLabel1Selected={isMonthly}
            setIsLabel1Selected={setIsMonthly}
          />
        </div>
        <div className={classes.plans}>
          {plans
            .filter((p: any) => (p.isYearly === isMonthly ? false : true))
            .map((plan: any, index: number) => (
              <div className={classes.plan} key={index}>
                <span className={classes.title}>{plan.name}</span>
                <span className={classes.desc}>{plan.description}</span>
                <span className={classes.price}>
                  ${plan.price}
                  <span className={classes.period}>
                    {!plan.isYearly ? "/month" : "/year"}
                  </span>
                </span>
                <span className={classes.detail}>{plan.subtitle}</span>
                <div className={classes.features}>
                  {plan.features.map((feature: any, fIndex: number) => (
                    <span className={classes.item} key={fIndex}>
                      {feature.notIncluded ? <FaTimes /> : <FaCheck />}
                      <span
                        className={feature.notIncluded ? classes.disabled : ""}
                      >
                        {feature.name}
                      </span>
                    </span>
                  ))}
                </div>
                {plan.isInactive ? (
                  <button
                    className={classes.inform}
                    onClick={() => handleOpenModal("Essential Smile Design")}
                  >
                    Contact Sales
                  </button>
                ) : user ? (
                  <button onClick={() => startActivation(plan.id)}>
                    Activate this plan
                  </button>
                ) : (
                  <button onClick={() => (window.location.href = "/login")}>
                    Sign in to activate
                  </button>
                )}
              </div>
            ))}
        </div>

        <div className={classes.reasons}>
          <span className={classes.title}>
            <span>Why Choose </span>
            <span className={classes.colored}>Tx-Genius?</span>
          </span>
          <div className={classes.items}>
            <div className={classes.reason}>
              <FaBrain size={35} />
              <span className={classes.heading}>Advanced AI Technology</span>
              <span className={classes.desc}>
                State-of-the-art artificial intelligence for precise dental
                diagnostics
              </span>
            </div>
            <div className={classes.reason}>
              <FaCloud size={35} />
              <span className={classes.heading}>Cloud-Based Solution</span>
              <span className={classes.desc}>
                Access your work anywhere, anytime with secure cloud storage
              </span>
            </div>
            <div className={classes.reason}>
              <FaUsers size={35} />
              <span className={classes.heading}>Team Collaboration</span>
              <span className={classes.desc}>
                Seamless collaboration tools for your entire dental team
              </span>
            </div>
          </div>
        </div>
      </div>

      <Footer />

      <Modal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        background="var(--blue-50)"
      >
        <InformMe
          planName={selectedPlan}
          monthlyOrYearly={isMonthly === true ? "Monthly" : "Annual"}
        />
      </Modal>
    </div>
  );
}
